import React, { } from 'react'
import { Button, message, Modal, Statistic, Tag } from 'antd'
import { EditOutlined, DeleteOutlined, ReloadOutlined, CopyOutlined, BarChartOutlined, Loading3QuartersOutlined, ExportOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import MainTable from '../../../components/Basic/MainTable'
import { useLocation, useNavigate } from 'react-router-dom'
import { delSegment, fetchSegment, reloadSegment } from '../../../apis/segment'
import dayjs from 'dayjs'

function SegmentList (props) {
  const { params, formatDate, viewOnly } = props
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { state, pathname } = location || {}
  const { type = 'criteria' } = state || {}
  const { handleFetchParams, fetchParams } = params

  const handleDelete = (id, data) => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t(`segment.${type}`)}`,
      content: `${ln_t('message.confirm.delete')} ${data.name}?`,
      onOk: async () => {
        const result = await delSegment(id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const handleReload = id => {
    Modal.confirm({
      title: `${ln_t('util.reload')}`,
      content: `${ln_t('message.confirm.reload')}?`,
      onOk: async () => {
        const result = await reloadSegment(id)
        if (result?.status === 202) {
          message.success(ln_t('message.success.reload'))
          navigate(0)
        }
      }
    })
  }

  const apiFunc = async () => fetchSegment(fetchParams)
  const previewStatus = {
    ready: { title: ln_t('segment.ready'), color: 'gold' },
    doing: { title: ln_t('segment.doing'), color: 'geekblue', icon: <Loading3QuartersOutlined spin /> },
    done: { title: ln_t('segment.done'), color: 'green' },
    error: { title: ln_t('segment.error'), color: 'red' }
  }
  const columns = [
    { title: ln_t('segment.name'), dataIndex: 'name', sorter: true },
    {
      title: ln_t('segment.quantity'),
      dataIndex: 'previewCount',
      render: (e, data) => data?.previewStatus === 'done'
        ? <Statistic value={e} />
        : <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}><Loading3QuartersOutlined spin /></div>
    },
    {
      title: ln_t('segment.status'),
      dataIndex: 'previewStatus',
      render: e => {
        const { title, icon, color } = previewStatus[e] || {}
        return <Tag style={{ width: '80px', cursor: 'default', textAlign: 'center' }} color={color} icon={icon}>{title}</Tag>
      }
    },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', sorter: true, render: e => formatDate(e) },
    { title: ln_t('segment.settingUpdatedAt'), dataIndex: 'updatedAt', sorter: true, render: e => formatDate(e) },
    { title: ln_t('segment.dataUpdatedAt'), dataIndex: 'previewUpdatedAt', sorter: true, render: e => e ? formatDate(e) : '-' },
    { title: ln_t('util.creator'), dataIndex: 'creatorName', render: e => e || '-' },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, data) => {
        const disableReload = dayjs(data.previewCreatedAt).format('YYYY-MM-DD') >= dayjs().format('YYYY-MM-DD')
        return <div className="action-btn">
          <>
            <Button size="small" icon={<ReloadOutlined />} disabled={disableReload} onClick={() => handleReload(id)} />
            {data?.dashboardSetting?.length > 0 && (
              <Button size="small" icon={<BarChartOutlined />} disabled={!data?.previewCount} onClick={() => navigate(`${pathname}/preview`, { state: { segmentInfo: data } })} />
            )}
            {viewOnly
              ? <Button size="small" icon={<ExportOutlined />} onClick={() => navigate(`${pathname}/detail `, { state: { data } })}>{ln_t('segment.viewDetail')}</Button>
              : <>
                  <Button size="small" icon={<CopyOutlined />} onClick={() => navigate(`${pathname}/new`, { state: { data } })}/>
                  <Button size="small" icon={<EditOutlined />} onClick={() => navigate(`${pathname}/edit`, { state: { data } })}/>
                  <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(id, data)}/>
                </>}
          </>
        </div>
      }
    }
  ]

  return (
    <MainTable
      columns={columns}
      rowKey="id"
      apiFunc={apiFunc}
      params={params}
      disabledRow={record => !record.previewCount || !record.status}
    />
  )
}

export default SegmentList
